import { Inject, Injectable } from '@angular/core';
import { LDClientSDK } from '@app/shared/services/ldclientsdk.token';
import type { LDClient } from 'launchdarkly-js-client-sdk';

/**
 * Shared LD flags for Reporting services and components
 */
@Injectable({
  providedIn: 'root',
})
export class ReportingFlagsService {
  /**
   * PD-45077: restrict access to the Content Completions Downloadable report
   */
  public readonly canViewContentCompletionsReport = this.ldClient.variation(
    'reporting-content-completions-download-08282020',
    false
  );

  /**
   * User should have the ability to filter In-App reports by date columns, when enabled
   */
  public readonly hasReportingColumnDateFilter = this.ldClient.variation(
    'reporting-column-date-filter',
    false
  );

  /**
   * User Can filter by all columns (up to 5 total, 10 selections per filter) when enabled
   * @TODO: clean up flag https://degreedjira.atlassian.net/browse/PD-85964
   */
  public readonly hasReportingMultiColumnFilter = this.ldClient.variation(
    'reporting-multi-column-filter',
    false
  );

  /**
   * User should have the ability to manage Configurations
   */
  public readonly hasReportingConfiguration = this.ldClient.variation(
    'reporting-transmitter-configuration-tab',
    false
  );

  /**
   * Some Orgs have the ability to filter by date range up to 2 years
   * @TODO: clean up flag https://degreedjira.atlassian.net/browse/PD-88371
   */
  public readonly hasReportingDateRangeFilterUpToTwoYears = this.ldClient.variation(
    'reporting-date-range-filter',
    false
  );

  /**
   * New reporting filters modal
   * @TODO: clean up flag https://degreedjira.atlassian.net/browse/PD-89223
   */
  public readonly hasReportingNewFiltersModal = this.ldClient.variation(
    'reporting-new-filters',
    false
  );

  /**
   * New reporting segements
   * @TODO: clean up flag https://degreedjira.atlassian.net/browse/PD-90830
   */
  public readonly hasReportingSegments = this.ldClient.variation(
    'reporting-segments',
    false
  );

  constructor(@Inject(LDClientSDK) private ldClient: LDClient) {}
}
